/**
 * Created by Viacheslav Stepanian on 24.06.2026
 */

HungryGamesCustomer.RECIPES_CONFIG = [
    {
        ingredients: [{ code: "hungrygames", stage: 0, amount: 14 }],
        order: [{ code: "crystal", stage: 0, amount: 1 }, { code: "sacks", stage: 0, amount: 1 }]
    },
    {
        ingredients: [{ code: "hungrygames", stage: 0, amount: 11 }],
        order: [{ code: "herochest", stage: 0, amount: 1 }, { code: "wands", stage: 2, amount: 1 }]
    },
    {
        ingredients: [{ code: "hungrygames", stage: 0, amount: 4 }],
        order: [{ code: "wands", stage: 2, amount: 1 }, { code: "worker", stage: 2, amount: 1 }]
    },
    {
        ingredients: [{ code: "hungrygames", stage: 0, amount: 16 }],
        order: [{ code: "crystal", stage: 1, amount: 1 }, { code: "sacks", stage: 1, amount: 1 }]
    },
    {
        ingredients: [{ code: "hungrygames", stage: 0, amount: 12 }],
        order: [{ code: "herochest", stage: 0, amount: 1 }, { code: "wands", stage: 2, amount: 1 }]
    },
    {
        ingredients: [{ code: "hungrygames", stage: 0, amount: 12 }],
        order: [{ code: "crystal", stage: 1, amount: 1 }, { code: "sacks", stage: 2, amount: 1 }]
    },
    {
        ingredients: [{ code: "hungrygames", stage: 0, amount: 9 }],
        order: [{ code: "worker", stage: 3, amount: 1 }, { code: "freechest", stage: 1, amount: 1 }]
    }
];
